import styled from 'styled-components';

import { ActionButton } from 'components/action-button';

export const EmptyStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 2rem;
  font-family: ${Styles.fontFamily.base};
  color: ${({ theme }) => theme.token('text-default')};

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const StyledActionButtonLink = styled(ActionButton)`
  margin-block-start: 1.5rem;
`;

export const HeaderText = styled.h5`
  margin: 0;
  font-size: 1.5rem;
  margin-block-start: 1.25rem;
  font-weight: ${Styles.fontWeight.black};
`;

export const SubText = styled.p`
  margin-block-start: 0.25rem;
  margin-block-end: 0;
  margin-inline: 2rem;
  font-size: 0.875rem;
  text-align: center;
`;

export const ImageWrapper = styled.div`
  height: 9.5rem;
`;
